import { render, staticRenderFns } from "./TdConversionSettings.vue?vue&type=template&id=3f32fdfa&scoped=true"
import script from "./TdConversionSettings.vue?vue&type=script&lang=ts"
export * from "./TdConversionSettings.vue?vue&type=script&lang=ts"
import style0 from "./TdConversionSettings.vue?vue&type=style&index=0&id=3f32fdfa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f32fdfa",
  null
  
)

/* custom blocks */
import block0 from "@/i18n/views/client-settings/td-conversion.json?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fusergram-front%2Fsrc%2Fviews%2Fclient-settings%2FTdConversionSettings.vue&external"
if (typeof block0 === 'function') block0(component)

export default component.exports